interface StorageItem {
    value: string;
    expiry: number;
  }
  
  // JWT token süresi (30 dakika - backend ile aynı)
  const JWT_EXPIRATION_TIME = 1800000;
  
  // Custom event for token expiration
  const TOKEN_EXPIRED_EVENT = 'tokenExpired';
  
  export const storage = {
    set: (key: string, value: string, ttl: number = JWT_EXPIRATION_TIME) => {
      const now = Date.now();
      const expiryTime = now + ttl;
  
      const item: StorageItem = { value, expiry: expiryTime };
      localStorage.setItem(key, JSON.stringify(item));
    },
  
    get: (key: string): string | null => {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
  
      // Önce JSON.parse ile StorageItem formatına uyuyor mu bakalım
      let parsed: StorageItem;
      try {
        const obj = JSON.parse(itemStr);
        if (
          typeof obj.value === 'string' &&
          typeof obj.expiry === 'number'
        ) {
          parsed = obj;
        } else {
          // JSON ama StorageItem değilse direkt dön
          return itemStr;
        }
      } catch {
        // JSON değilse (örneğin eski mock token) direkt dön
        return itemStr;
      }
  
      const now = Date.now();
  
      if (now > parsed.expiry) {
        localStorage.removeItem(key);
        if (key === 'token') {
          window.dispatchEvent(new Event(TOKEN_EXPIRED_EVENT));
        }
        return null;
      }
  
      return parsed.value;
    },
  
    remove: (key: string) => {
      localStorage.removeItem(key);
    },
  
    clear: () => {
      localStorage.clear();
    },
  
    onTokenExpired: (callback: () => void) => {
      window.addEventListener(TOKEN_EXPIRED_EVENT, callback);
      return () => window.removeEventListener(TOKEN_EXPIRED_EVENT, callback);
    }
  };
  